module.exports = __webpack_public_path__ + "img/za.f23d0f6e.png";